import deleteCookie from '@/utils/deleteCookie'
import store from '@/store/BookingStore'

const logout = () => {
    deleteCookie("user-id-token")
    deleteCookie("user-access-token")
    deleteCookie("user-refresh-token")
    store.commit('setLoggedUser', null)
    store.commit('setIsSubscribeNewsletter', { email: false, sms: false })
}

export default logout